<div class="d-flex flex-wrap align-items-center gap-2 mt-2 list-pagination-bar">
  <label class="mb-0 small" [for]="selectId()">{{ 'ADMIN.PER_PAGE' | translate }}</label>
  <select
    [id]="selectId()"
    class="form-select form-select-sm w-auto"
    [ngModel]="meta().per_page"
    (ngModelChange)="onPerPageChange($event)"
    [disabled]="loading()"
    [attr.aria-label]="'ADMIN.PER_PAGE' | translate"
  >
    @for (opt of perPageOptions(); track opt) {
      <option [value]="opt">{{ opt }}</option>
    }
  </select>
  <span class="ms-2">{{ 'ADMIN.PAGE_LABEL' | translate:{ current: meta().current_page, last: meta().last_page } }}</span>
  <app-mdb-button
    [text]="'ADMIN.PREV'"
    color="secondary"
    [outlined]="true"
    size="sm"
    [disabled]="meta().current_page <= 1 || loading()"
    [attr.title]="'ADMIN.PREV' | translate"
    [attr.aria-label]="'ADMIN.PREV' | translate"
    (onClick)="previous()"
  />
  <app-mdb-button
    [text]="'ADMIN.NEXT'"
    color="secondary"
    [outlined]="true"
    size="sm"
    [disabled]="meta().current_page >= meta().last_page || loading()"
    [attr.title]="'ADMIN.NEXT' | translate"
    [attr.aria-label]="'ADMIN.NEXT' | translate"
    (onClick)="next()"
  />
</div>
